import React, {useState, useEffect} from 'react'
import PropTypes from "prop-types"
import { Field, reduxForm } from "redux-form"

import DropezoneInput from "./dropezone-input"
import Footer from "./form-footer"
import Input from "./input"
import ProductItem from "../product-item"
import SegmentedControl from "../../../components/segmented-control"

const formName = "shop-product"

const TypeSelector = ({input}) => {
  return (
    <SegmentedControl onChange={input.onChange} value={input.value} >
      <span value="product">Product</span>
      <span value="group">Group</span>
    </SegmentedControl>
  )
}

const GroupSelector = ({groups}) => {
  return (
    <div className="form-group">
      <label>Assign to group</label>
      <Field name="groupId" component="select">
        <option value="">None</option>
        {groups.map(group => <option key={group.id} value={group.id}>{group.title}</option>)}
      </Field>
    </div>
  )
}

GroupSelector.propTypes = {groups: PropTypes.array.isRequired}

const QuantityInStockInput = ({input, productId, products}) => {
  return (
    <ProductItem
      productId={productId}
      products={products}
      canChangeQuantityInStock={true}
      showQuantityInStock={true}
      quantityInStock={input.value}
      onChangeQuantityInStock={input.onChange}
    />
  )
}

const ProductForm = (props) => {
  const [loading, setLoading] = useState(false)
  const {editProductId, products, type, availableGroups} = props
  const currencyName = props.currency == 'usd' ? '' : ` (${props.currency.toUpperCase()})`
  const isGroup = type === "group"

  useEffect(() => {
    if (props.submitFailed) setLoading(false)
  },[props.submitFailed])

  const onSubmit = (data) => {
    setLoading(true)
    props.handleSubmit(data)
  }

  return (
    <form className='shop-product-form' onSubmit={onSubmit}>
      { loading && <div className='animated-spinner' /> }
      {editProductId &&
        <Field
          name="quantityInStock"
          component={QuantityInStockInput}
          productId={editProductId}
          products={products}
        />
      }
      <Field component="input" type="hidden" name="id" />
      {!editProductId && <div className="form-group"><Field component={TypeSelector} name="type" /></div>}
      <div className="form-group">
        <Input type="text" label="Name" name="title" />
      </div>
      <div className="form-group">
        <Input type="number" label={`Price${currencyName}`} name="price" disabled={isGroup} prefix="$"/>
        <Input type="number" label="Tax" name="ownTaxPercent" prefix="%"/>
      </div>
      {!isGroup && <GroupSelector groups={availableGroups} />}
      <div className="form-group">
        Change Image
        <Field component={DropezoneInput} name="image" />
      </div>
      <Footer {...props} />
    </form>
  )
}

ProductForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  availableGroups: PropTypes.array.isRequired,
  products: PropTypes.object,
  editProductId: PropTypes.number,
  type: PropTypes.string,
}

export default reduxForm({form: formName})(ProductForm)
